"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnicalImpression = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
const technical_indicator_enum_1 = require("../../@types/incoming/enum/technical-indicator.enum");
const technical_impressions_data_1 = require("./data/technical-impressions.data");
class TechnicalImpression {
    constructor(investorType) {
        this.investorType = investorType;
    }
    getAll(indicators) {
        const outputImpressions = [];
        const { MACD_12_26: macd } = indicators;
        let buyPoints = 0;
        let sellPoints = 0;
        let overBuyPoints = 0;
        let overSellPoints = 0;
        let lessVolatilityPoints = 0;
        let moreVolatilityPoints = 0;
        const summaryKeyNum = Object.keys(indicators).findIndex((key) => key === 'Summary');
        Object.values(indicators).forEach((indicator, i) => {
            if (i !== summaryKeyNum) {
                switch (indicator) {
                    case technical_indicator_enum_1.eTechnicalIndicator.BUY:
                        return buyPoints++;
                    case technical_indicator_enum_1.eTechnicalIndicator.SELL:
                        return sellPoints++;
                    case technical_indicator_enum_1.eTechnicalIndicator.STRONG_BUY:
                        return overBuyPoints++;
                    case technical_indicator_enum_1.eTechnicalIndicator.STRONG_SELL:
                        return overSellPoints++;
                    case technical_indicator_enum_1.eTechnicalIndicator.LESS_VOLATILITY:
                        return lessVolatilityPoints++;
                    case technical_indicator_enum_1.eTechnicalIndicator.MORE_VOLATILITY:
                        return moreVolatilityPoints++;
                    default:
                        return;
                }
            }
        });
        const points = {
            buyPoints,
            lessVolatilityPoints,
            overBuyPoints,
            moreVolatilityPoints,
            overSellPoints,
            sellPoints,
        };
        if (this.investorType === investor_type_enum_1.eInvestorType.DAY_TRADER) {
            const dayTraderImpressions = this.getDayTraderImpressions(points, macd);
            dayTraderImpressions.forEach((impression) => impression && outputImpressions.push(impression));
        }
        else if (this.investorType === investor_type_enum_1.eInvestorType.SWING_TRADER) {
            const swingTraderImpressions = this.getSwingTraderImpressions(points, macd);
            swingTraderImpressions.forEach((impression) => impression && outputImpressions.push(impression));
        }
        else if (this.investorType === investor_type_enum_1.eInvestorType.BUY_AND_HOLDER) {
            const holderImpressions = this.getHolderImpressions(points, macd);
            holderImpressions.forEach((impression) => impression && outputImpressions.push(impression));
        }
        return outputImpressions;
    }
    getDayTraderImpressions(points, macd) {
        const impressions = [];
        const { buyPoints, moreVolatilityPoints, overBuyPoints, overSellPoints, sellPoints, } = points;
        if (overBuyPoints >= 4) {
            impressions.push(this.getDisplayableImpression(0));
        }
        else if (overSellPoints >= 4) {
            impressions.push(this.getDisplayableImpression(1));
        }
        if (moreVolatilityPoints >= 4) {
            impressions.push(this.getDisplayableImpression(2));
        }
        if (buyPoints >= 7) {
            impressions.push(this.getDisplayableImpression(3));
        }
        else if (sellPoints >= 7) {
            impressions.push(this.getDisplayableImpression(4));
        }
        if (macd === technical_indicator_enum_1.eTechnicalIndicator.BUY) {
            impressions.push(this.getDisplayableImpression(5));
        }
        else if (macd === technical_indicator_enum_1.eTechnicalIndicator.SELL) {
            impressions.push(this.getDisplayableImpression(6));
        }
        return impressions;
    }
    getSwingTraderImpressions(points, macd) {
        const impressions = [];
        const { buyPoints, overBuyPoints, overSellPoints, sellPoints, moreVolatilityPoints, } = points;
        if (overBuyPoints >= 3) {
            impressions.push(this.getDisplayableImpression(0));
        }
        else if (overSellPoints >= 3) {
            impressions.push(this.getDisplayableImpression(1));
        }
        if (moreVolatilityPoints >= 3) {
            impressions.push(this.getDisplayableImpression(2));
        }
        if (buyPoints >= 6) {
            impressions.push(this.getDisplayableImpression(3));
        }
        else if (sellPoints >= 6) {
            impressions.push(this.getDisplayableImpression(4));
        }
        if (macd === technical_indicator_enum_1.eTechnicalIndicator.BUY) {
            impressions.push(this.getDisplayableImpression(5));
        }
        else if (macd === technical_indicator_enum_1.eTechnicalIndicator.SELL) {
            impressions.push(this.getDisplayableImpression(6));
        }
        return impressions;
    }
    getHolderImpressions(points, macd) {
        const impressions = [];
        const { buyPoints, moreVolatilityPoints, overSellPoints, sellPoints, overBuyPoints, } = points;
        if (overBuyPoints >= 4) {
            impressions.push(this.getDisplayableImpression(0));
        }
        else if (overSellPoints >= 4) {
            impressions.push(this.getDisplayableImpression(1));
        }
        if (moreVolatilityPoints >= 3) {
            impressions.push(this.getDisplayableImpression(2));
        }
        if (buyPoints >= 8) {
            impressions.push(this.getDisplayableImpression(3));
        }
        else if (sellPoints >= 8) {
            impressions.push(this.getDisplayableImpression(4));
        }
        if (macd === technical_indicator_enum_1.eTechnicalIndicator.BUY) {
            impressions.push(this.getDisplayableImpression(5));
        }
        else if (macd === technical_indicator_enum_1.eTechnicalIndicator.SELL) {
            impressions.push(this.getDisplayableImpression(6));
        }
        return impressions;
    }
    getDisplayableImpression(id) {
        return technical_impressions_data_1.technicalImpressionsList.find((item) => item.id === id);
    }
}
exports.TechnicalImpression = TechnicalImpression;
//# sourceMappingURL=technical.impression.js.map